import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import type { ElForm } from 'element-ui/types/form';
import { divide } from 'lodash';
import DialogFactory from '../picker/dialogFactory';
import IPSDialog from '../picker/dialog';
import style from './style.vue';
import SelectClassDialog from './selectClassDialog';
import { IPSService } from '@/services/ipsServices';
import { QinggerLibUtils, noop } from '@/util';
const isset = QinggerLibUtils.isset;

@DialogFactory
@Component({
  mixins: [style],
})
export default class AddFilterItemDialog extends IPSDialog {
  $refs: {
    form: ElForm;
  };

  title = '添加一级筛选项';

  filterItemInfo: ItemObject = {
    className: '',
    classId: 0,
    classSort: 1,
  };

  width = '600px';

  selectedClass: ItemObject = {};

  sgId = 0;

  classId = 0;

  rules = {
    className: [{ required: true, validator: this.classNameValidate, trigger: ['change', 'blur'] }],
    classCode: [{ required: true, message: '请选择分类', validator: this.classCodeValidate, trigger: 'change' }],
  };

  tableData = [];

  addType = 1; // 1添加一级分类 2 添加二级分类

  classCode = ''; // 添加二级分类时其父级分类code;

  parentName = '';

  parentId = 0;
  maxLength: number;

  async mounted() {
    this.classId && (this.filterItemInfo = await this.getData());
    this.selectedClass = this.tableData.find(v => v.value_no === this.filterItemInfo.vAttributeValue) || {};
    this.tableData = this.filterItemInfo.parentVAttributeValue ? this.tableData.filter(v => v.parent_no === this.filterItemInfo.parentVAttributeValue) : this.tableData;
  }

  classCodeValidate(rule, value, callback) {
    if (!this.selectedClass.value_no) {
      callback(new Error('请选择分类'));
    } else {
      callback();
    }
  }

  classNameValidate(rule, value, callback) {
    const tmpStr = value.trim().replace(/[\u4E00-\u9FA5]/gi, 'aa');
    if (!value) {
      callback(new Error(' '));
    }
    if (tmpStr.length > 20) {
      callback(new Error('字符长度不能超过20'));
    } else {
      callback();
    }
  }

  validateNum() {
    if (this.inputMaxLength >= 20) {
      this.$refs.form.validate(noop);
      return;
    }
  }

  get inputMaxLength() {
    const tmpStr = this.filterItemInfo.className.trim().replace(/[\u4E00-\u9FA5]/gi, 'aa');
    return tmpStr.length;
  }

  /**
   * 网点组获取关联分类
   * @param null
   * @return {Promise<any>}
   */
  public getAttributeList(): Promise<any> {
    return IPSService.productAttrList().then((res) => {
      return isset(res, 'list') ? res.list : [];
    });
  }

  getData() {
    return IPSService.classFilterInfo({
      postParams: {
        classId: this.classId,
        sgId: this.sgId,
      },
    }).then((response) => {
      return response;
    });
  }

  onSelectClass() {
    if (this.addType === 1 && this.classId) {
      return;
    }
    SelectClassDialog.open({ attrbuteList: this.tableData, selectType: this.addType }).then((result) => {
      this.selectedClass = result;
      this.$refs.form.validateField('classCode', noop);
    }, noop);
  }

  beforeConfirm() {
    this.$refs.form.validate((result) => {
      if (result) {
        if (this.addType === 1 || this.classId) {
          IPSService.classFilterSave({
            postParams: {
              sgId: this.sgId,
              className: this.filterItemInfo.className,
              classSort: this.filterItemInfo.classSort || 1,
              vAttributeValue: this.selectedClass.value_no,
              classId: this.filterItemInfo.classId || 0,
            },
          }).then(
            (response) => {
              this.confirmloading = false;
              this.$emit('result');
              this.$emit('hidden');
            },
            () => {
              this.confirmloading = false;
            },
          );
        } else {
          let classId = this.filterItemInfo.classId;
          this.addType && !classId && (classId = this.parentId);
          IPSService.classFilterSecondSave({
            postParams: {
              sgId: this.sgId,
              classId,
              className: this.filterItemInfo.className,
              vAttributeValue: this.selectedClass.value_no,
              classSort: this.filterItemInfo.classSort || 1,
            },
          }).then(
            (response) => {
              this.confirmloading = false;
              this.$emit('result');
              this.$emit('hidden');
            },
            () => {
              this.confirmloading = false;
            },
          );
        }
      } else {
        this.confirmloading = false;
      }
    });
  }

  onRemoveClass() {
    this.selectedClass = {};
    this.$refs.form.validateField('classCode', noop);
  }

  renderContent(h) {
    return (
      <div class="add-filter-item-container">
        <el-form props={{ model: this.filterItemInfo }} ref="form" label-position="left" label-width="110px" rules={this.rules}>
          {!!(this.addType === 2 && this.classId) && (
            <el-form-item label="上级筛选项">
              <div>{this.parentName}</div>
            </el-form-item>
          )}
          <el-form-item label="筛选项名称" prop="className">
            <el-input v-model={this.filterItemInfo.className} onChange={this.validateNum.bind(this)}>
              <div class="font-size-12" slot="suffix">
                <span>{this.inputMaxLength}</span>/<span>20</span>
              </div>
            </el-input>
          </el-form-item>
          <el-form-item label="绑定主档分类" prop="classCode">
            <span class={['scopeSpan', !!(this.addType === 1 && this.classId) && 'disabled']} onClick={this.onSelectClass.bind(this)}>
              请选择
            </span>
            <br />
            {!!this.selectedClass.value_no && (
              <el-tag closable={!(this.addType === 1 && this.classId)} onClose={this.onRemoveClass.bind(this)}>
                {this.selectedClass.title}
              </el-tag>
            )}
          </el-form-item>
        </el-form>
      </div>
    );
  }
}
